export const animationStyles = {
  opacity: 0,
  transition: 'none',
  animation: 'fadeIn 350ms ease-in-out 1200ms forwards',
}

export const fadeOutStyles = {
  opacity: 1,
  animation: 'fadeOut 450ms ease-in-out',
}

export const getFloaterStyles = ({
  step,
  isPhone,
  isTablet,
}: {
  step: number
  isPhone: boolean
  isTablet: boolean
}) => {
  const floater: React.CSSProperties = { ...animationStyles }
  const marginLeft = isPhone ? '0px' : isTablet ? '30px' : '41px'

  if (step === 2 && isTablet) floater.marginLeft = marginLeft
  if (step === 3) floater.marginLeft = marginLeft

  return {
    floater,
    floaterOpening: { opacity: 0 },
    floaterWithAnimation: { opacity: 0 },
  }
}
